import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Styles
import styles from '../../../styles/global.pcss';

const cn = classNames.bind(styles);

const AccordionModel = ({ data: { description } }) => (
  <div className={cn('model__description')}>
    <Text size="size5-r-s">{description}</Text>
  </div>
);

AccordionModel.propTypes = {
  data: PropTypes.objectOf({
    description: PropTypes.string,
  }),
};

export { AccordionModel };
